export const PUSH_NOTIFICATION = {
  BASE_PATH: "/others/push-notification/",
  ADD_PATH() {
    return this.BASE_PATH + "add";
  },
  ADD_BUTTON_TITLE: "Add Push Notification",
  LIST_PAGE_TITLE: "Push Notification List",
  ADD_NEW_TITLE: "Add New Push Notification",
  GET_ALL: "/push-notification",
  GET_ONE: "/push-notification/edit/",
  CREATE: "/push-notification/create",
  DELETE: "/push-notification/delete/",
  SEND: "/push-notification/send/",
};
